import { Box, makeStyles, Typography } from "@material-ui/core";
import { Warning } from "@material-ui/icons";
import { useValidation } from "../../hooks/useValidation";

const useStyles = makeStyles((theme) => ({
  iconSection: {
    padding: 10,
  },
  icon: {
    fontSize: "3rem",
  },
  messageSection: {},
}));

type Validation = ReturnType<typeof useValidation>;

type ItemValidationProps = {
  validation: Validation;
};

export const ItemValidation: React.FC<ItemValidationProps> = ({
  validation,
}) => {
  const classes = useStyles();
  return (
    <Box display="flex" alignItems="center">
      <div className={classes.iconSection}>
        <Warning className={classes.icon} />
      </div>
      <Typography className={classes.messageSection} data-test="validation-text">
        <b>{getMessage(validation)}</b>
      </Typography>
    </Box>
  );
};

const getMessage = ({
  isReady,
  isOk,
  isActionsOk,
  isRecipientsOk,
  isFormOk,
}: Validation) => {
  if (!isReady) {
    return null;
  }
  if (!isActionsOk) {
    return "Missing required action(s)!";
  }
  if (!isRecipientsOk) {
    return "The request does not have any recipients yet!";
  }
  if (!isFormOk) {
    return "The request must have a request type, subject and message!";
  }
  return null;
};
